import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import BlogClassicData from '../data/blog/BlogClassic.json';
import BlogDetailsContainer from '../container/BlogGrid/BlogDetailsContainer';
import CallToAction from '../container/CallToAction/CallToAction';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import axios from "axios";

const BlogDetails = () => {
    const { id } = useParams(); 

    const baseUri = "https://tetrahed.s3.us-east-1.amazonaws.com/BlogClassic.json";
    const [fetchedData, setFetchedData] = useState([]);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const response = await axios.get(baseUri);
                if (response.status === 200) {
                    setFetchedData(response.data);
                } else {
                    // Fallback to local data if API fails
                    setFetchedData(BlogClassicData);
                }
            } catch (error) {
                console.error('Error fetching data, falling back to local:', error.message);
                // Fallback to local data on error
                setFetchedData(BlogClassicData);
            }
        };

        fetchDataFromAPI();
    }, []);

    useEffect(() => {
        if (fetchedData.length > 0) {
            const blogData = fetchedData.find(blog => blog.seoUrl === id);
            setData(blogData);
            setLoading(false);
        }
    }, [id, fetchedData]);

    if (loading) {
        return (
            <div className="loaderMainDiv">
                <span className="loader"></span>
            </div>
        );
    }

    if (!data) {
        return (
            <React.Fragment>
                <SEO title="Blog Not Found" />
                <Header bgStyle={{background: '#030e22'}} />
                <div style={{textAlign: 'center', padding: '50px'}}>
                    <h2>Blog post not found.</h2>
                    <p>Sorry, we couldn't find the blog post you're looking for.</p>
                </div>
                <Footer />
                <ScrollToTop />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <SEO title={data.metaTitle} description={data.metaDescription} />
            <Header bgStyle={{background: '#030e22'}} />
            <BlogDetailsContainer data={data} />
            <CallToAction sectionTitleContent="" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default BlogDetails;
